export default "__VITE_ASSET__aGdrsID1__"